import Vue from "vue";

const state = {
  notifications: null,
  messages: [],
};

const getters = {
  notifications: (state) => state.notifications,
  messages: (state) => state.messages,
};

const actions = {
  fetchMessages({ commit, rootState }) {
    firebase
      .database()
      .ref("messages")
      .on("child_added", (snapshot) => {
        commit("setMessages", {
          ...snapshot.val(),
          id: snapshot.key,
        });
      });
  },
  addNotification({ commit }, payload) {
    console.log(payload);
    firebase
      .database()
      .ref("notifications")
      .push(payload)
      .then(() => {
        commit("setNotifications", {
          message: "Verification rejected successfully",
          type: "success",
        });
      })
      .catch((error) => console.log(error.message));
  },

  updateUsers({ commit }, payload) {
    let id = payload.id;
    delete payload.id;

    firebase
      .database()
      .ref("users")
      .child(id)
      .update(payload)
      .then(() => {
        commit("setNotifications", {
          message: "User updated successfully",
          type: "success",
        });
      })
      .catch((error) => {
        commit("setNotifications", { message: error.message, type: "error" });
      });
  },
  blockUser({ commit }, payload) {
    firebase
      .database()
      .ref("users")
      .child(payload)
      .update({ status: "blocked" })
      .then(() => {
        commit("setNotifications", {
          message: "User blocked successfully",
          type: "success",
        });
      })
      .catch((error) => {
        commit("setNotifications", { message: error.message, type: "error" });
      });
  },
  unblockUser({ commit }, payload) {
    firebase
      .database()
      .ref("users")
      .child(payload)
      .update({ status: "active" })
      .then(() => {
        commit("setNotifications", {
          message: "User unblocked successfully",
          type: "success",
        });
      })
      .catch((error) => {
        commit("setNotifications", { message: error.message, type: "error" });
      });
  },

  rejectUser({ commit }, payload) {
    firebase
      .database()
      .ref("users")
      .child(payload.id)
      .update({
        isverified: false,
        submission: false,
        rejection_reason: payload.reason,
      })
      .then(() => {
        commit("setNotifications", {
          message: "User rejected successfully",
          type: "success",
        });
      })
      .catch((error) => {
        commit("setNotifications", { message: error.message, type: "error" });
      });
  },
  VerifyUser({ commit }, payload) {
    firebase
      .database()
      .ref("users")
      .child(payload)
      .update({ isverified: true, rejection_reason: "",submission:false, })
      .then(() => {
        commit("setNotifications", {
          message: "User verified successfully",
          type: "success",
        });
      })
      .catch((error) => {
        commit("setNotifications", { message: error.message, type: "error" });
      });
  },
  DeleteUser({ commit }, payload) {
    console.log(payload);
    firebase
      .database()
      .ref("users")
      .child(payload)
      .update({ status: "deleted" })
      .then(() => {
        commit("setNotifications", {
          message: "User deleted successfully",
          type: "success",
        });
      })
      .catch((error) => {
        commit("setNotifications", { message: error.message, type: "error" });
      });
  },
};
const mutations = {
  setMessages: (context, payload) => state.messages.push(payload),

  setNotifications: (state, payload) => {
    state.notifications = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
